// @ts-nocheck

import { FormWidget, Image, PMButton, PMCard, PMGrid } from "lib";

import { errorSerializer } from "helperFn/errorSerializer";
import { useSnackbar } from "notistack";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLoginApiMutation } from "store/apiSlice";
import { setStore } from "store/appSlice";
function Login() {
    // Hold page variables to avoid polluting variable space
    var page = {
        data: {},
        parameters: {
            route: {},
        },
    };

    const { enqueueSnackbar } = useSnackbar();
    const [loginApiMutationTrigger, loginApiMutationResult] = useLoginApiMutation();
    const history = useNavigate();
    const dispatch = useDispatch();
    dispatch(setStore({ currentPageTitle: "" }));

    const fpredirect = (data) => {
        history("/forgot-password/");
    };

    const forgotPassword = (data) => {
        fpredirect(data);
    };

    const afterLogin = (data) => {
        history("/policy-renewals-dashboard");
    };

    const storeLoginData = (data) => {
        var formatedData = {
            authToken: data["access_token"],
            userId: data["user_id"],
            username: data["user"],
            email: data["email"],
            phone: data["phone"],
        };
        dispatch(setStore(formatedData));
    };

    const loginApi = async (data) => {
        var apiData = data;

        if (apiData) {
            loginApiMutationTrigger({ username: apiData["username"], password: apiData["password"] })
                .unwrap()
                .then((data) => {
                    storeLoginData(data);
                    afterLogin(data);
                })
                .catch((error) => {
                    console.log(error);
                    enqueueSnackbar(errorSerializer(error), { variant: "error" });
                });
        }
    };

    const loginForm = (data) => {
        loginApi(data);
    };

    return (
        <div className="builder_wrapper">
            <PMGrid
                container={true}
                background="#007493"
                sx={{ direction: "column", alignItems: "center", justifyContent: "center" }}
                item={true}
                minHeight="100vh"
            >
                <PMGrid item={true} container={true} md={3} direction="column" background="#FFFFFF">
                    <PMCard raised={true}>
                        <PMGrid container={true} rowSpacing={3} alignSelf="center">
                            <PMGrid
                                item={true}
                                xs={12}
                                container={true}
                                sx={{ "margin-top": 10 }}
                                justifyContent="center"
                            >
                                <Image image="https://www.permutehq.com/assets/images/logo/logo.svg"></Image>
                            </PMGrid>

                            <PMGrid item={true} xs={12}>
                                <FormWidget
                                    direction="column"
                                    header="Enter Email and password to login"
                                    headerBackgroundColor="#FFFFFF"
                                    Onsubmit={loginForm}
                                    fieldsets={[
                                        {
                                            direction: "column",
                                            fields: [
                                                {
                                                    label: "Email",
                                                    name: "username",
                                                    type: "text",
                                                    required: true,
                                                    fullWidth: true,
                                                },
                                                {
                                                    label: "Password",
                                                    name: "password",
                                                    type: "password",
                                                    required: true,
                                                    fullWidth: true,
                                                },
                                            ],
                                        },
                                    ]}
                                ></FormWidget>

                                <PMGrid container={true} sx={{ "margin-top": 10 }} justifyContent="flex-end" xs={12}>
                                    <PMButton
                                        label="forgot password ?"
                                        sx={{ "align-self": "right" }}
                                        onClick={forgotPassword}
                                    ></PMButton>
                                </PMGrid>
                            </PMGrid>
                        </PMGrid>
                    </PMCard>
                </PMGrid>
            </PMGrid>
        </div>
    );
}
export default Login;
